import { render, staticRenderFns } from "./Neo4jReportsSlot.vue?vue&type=template&id=058bed14&scoped=true"
import script from "./Neo4jReportsSlot.vue?vue&type=script&lang=js"
export * from "./Neo4jReportsSlot.vue?vue&type=script&lang=js"
import style0 from "./Neo4jReportsSlot.vue?vue&type=style&index=0&id=058bed14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058bed14",
  null
  
)

export default component.exports